import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { ReturnPage, returnHintOf } from '../../../receptora/journey/return-page.tsx';

// What the receiver appends to the return URL: the connection, and a hint of the outcome.
const returnSearch = Schema.toStandardSchemaV1(
  Schema.Struct({
    connectionId: Schema.optionalKey(Schema.String),
    result: Schema.optionalKey(Schema.String),
  }),
);

export const Route = createFileRoute('/receptora/retorno')({
  validateSearch: returnSearch,
  component: ReturnRoute,
});

function ReturnRoute(): JSX.Element {
  const { connectionId, result } = Route.useSearch();
  return (
    <ReturnPage
      target={
        connectionId === undefined || connectionId === ''
          ? { kind: 'unidentified' }
          : { kind: 'connection', connectionId, hint: returnHintOf(result ?? '') }
      }
    />
  );
}
